import { Component, input } from '@angular/core';
import { MatListModule } from '@angular/material/list';

@Component({
    selector: 'inspekt-widget-menu',
    templateUrl: './widget-menu.component.html',
    styleUrls: ['./widget-menu.component.scss'],
    imports: [MatListModule]
})

export class WidgetMenuComponent {
  readonly items = input<any[]>(undefined);
  img = document.createElement('img'); // image for drag and drop custom

  drag(ev, newWidgetName) {
    ev.dataTransfer.setDragImage(this.img, 0, 0);
    ev.dataTransfer.setData('widget', newWidgetName);
  }

  allowDrop(ev) {
    ev.preventDefault();
  }
}
